import { render, staticRenderFns } from "./PlatformSms.vue?vue&type=template&id=57d6dccf&scoped=true&"
import script from "./PlatformSms.vue?vue&type=script&lang=js&"
export * from "./PlatformSms.vue?vue&type=script&lang=js&"
import style0 from "./PlatformSms.vue?vue&type=style&index=0&id=57d6dccf&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57d6dccf",
  null
  
)

export default component.exports